import React, { useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { Button, Badge, Tooltip } from "antd";
import { tokenKey } from "../../../api/OAuth";
import { baseApiUrl, userHasRolePermission } from "../../../api/ApiUtils";
import { getNewNotificationCount } from "../../../api/NotificationApi";
import { Bell } from "react-feather";

function AdnNotification({ handleNotifications }) {
  const [notificationNumber, setNotificationNumber] = useState(0);
  const [, setRestrictedAccess] = useState(false);

  useEffect(() => {
    if (
      userHasRolePermission(
        "Admin,Human Resources,Manager,Marketing Communications"
      )
    ) {
      setSignalRConnection();
      getUserNewCountNotifications();
    } else {
      setRestrictedAccess(true);
    }
  }, []);

  const setSignalRConnection = () => {
    const loginToken = localStorage.getItem(tokenKey);
    const hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${baseApiUrl}/api/v1/notify-user`, {
        accessTokenFactory: () => `${loginToken}`,
      })
      .build();

    hubConnection
      .start()
      .then(() => console.log("SignalR connection started"))
      .catch(function (error) {
        return console.error(
          `SignalR error while starting connection: ${error.toString()}`
        );
      });

    hubConnection.on("notifyUser", (total) => {
      if (isNaN(total) && total < 0) {
        setNotificationNumber(0);
      } else {
        setNotificationNumber(total);
      }
    });
  };

  function getUserNewCountNotifications() {
    getNewNotificationCount()
      .then((total) => {
        setNotificationNumber(total.data);
      })
      .catch((error) => {
        setNotificationNumber(0);
        console.error(
          `Could not fetch the number of user notifications. Error: ${error}`
        );
      });
  }

  let notificationTitle = "Notifications";
  switch (notificationNumber) {
    case 0:
      notificationTitle = "You have no new notifications";
      break;
    case 1:
      notificationTitle = "You have 1 new notification";
      break;
    default:
      if (notificationNumber) {
        notificationTitle =
          "You have " + notificationNumber + " new notifications";
      } else {
        notificationTitle = "Notifications";
      }
      break;
  }

  return (
    <>
      <Tooltip title={notificationTitle}>
        <Button
          type="text"
          onClick={handleNotifications}
          icon={
            <Badge
              offset={[0, 2]}
              color={"var(--adnlightblue)"}
              size={"small"}
              count={notificationNumber !== 0 ? notificationNumber : <></>}
              showZero
            >
              <Bell size={22} />
            </Badge>
          }
        />
      </Tooltip>
    </>
  );
}

export default AdnNotification;
